import { DistrictSimpleDto } from 'src/app/common/dtos/district.dto';
import { UserDTO } from 'src/app/common/state/user/user.dto';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { DistrictAPIResponse } from './district-list.responses';

export interface GetAllProFormsAPIResponse {
  items: ProFormsAPIResponse[];
  _links: {
    self: string;
    first: string;
    last: string;
    prev?: string;
    next?: string;
  };
  _meta: PaginationDTO;
}

export interface ItemProFormsAPIResponse {
  item: ProFormsAPIResponse;
}

export interface ProFormsAPIResponse {
  id: number;
  title: string;
  outro: string;
  creator_user_id: number;
  district_id: number;
  is_shared: number;
  anonymity: ProFormAnonymity;
  status: ProFormStatus;
  type: ProFormType;
  show_missed: number;
  show_answers: number;
  passing_grade: number;
  sections?: ProFormsSectionAPIResponse[];
  district?: DistrictAPIResponse;
  creator?: UserDTO;
  districtsSharedWith?: ProFormShareItemResponse[];
  districtsExcludedFrom?: ProFormShareItemResponse[];
  submissionCount?: number;
  lastSubmission?: number;
  hasSubmission?: boolean;
  submissions?: ProFormsSubmissionAPIResponse[];
  questions?: ProFormsQuestionAPIResponse[];
  instructional_insights_export: number;
  is_locked?: number;
}

export enum ProFormAnonymity {
  NONE = 'none',
  REQUIRED = 'required',
}

export enum ProFormType {
  SURVEY = 'survey',
  QUIZ = 'quiz',
  OBSERVATION = 'observation',
  CALIBRATION = 'calibration',
}

export enum ProFormStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export enum ProFormContext {
  COACHLOG = 'egrowe_coachlog',
  PD_SESSION = 'pd_session',
  SELF = 'proform_form',
}

export interface ProFormsSectionAPIResponse {
  id: number;
  proform_form_id: number;
  title: string;
  description: string;
  sort_order: number;
  is_conditional: number;
  conditional_question_id: number | null;
  conditional_question_answer_option_id: number | null;
  questions: ProFormsQuestionAPIResponse[];
}

export interface ProFormsQuestionAPIResponse {
  id: number;
  proform_form_id: number;
  field_type: ProformFieldTypes;
  question: string;
  helper_text: string;
  required: number;
  allow_other_answer: number;
  sort_order: number;
  field_type_specs: string;
  proform_form_section_id: number;
  answerOptions: ProFormsAnswerOptionAPIResponse[];
}

export interface UpdateProFormsQuestionAPIResponse {
  item: {
    id: number;
    proform_form_id: number;
    field_type: string;
    question: string;
    helper_text: string;
    required: number;
    allow_other_answer: number;
    sort_order: number;
    field_type_specs: string;
    proform_form_section_id: number;
  };
}

export interface ProFormsAnswerOptionAPIResponse {
  id: number;
  proform_form_id: number;
  proform_form_question_id: number;
  answer: string;
  is_correct: number;
  sort_order: number;
  next_section_override: string;
}

export interface ProFormShareItemResponse {
  id: number;
  proform_form_id: number;
  district_id: number;
  is_shared: number;
  district: DistrictSimpleDto;
}

export enum ProformFieldTypes {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  SCALE = 'scale',
  DROPDOWN = 'dropdown',
  ATTACHMENT = 'attachment',
  CONTENT_BLOCK = 'contentblock',
  CHECKBOX_GRID = 'checkboxgrid',
  // PAGEBREAK = 'pagebreak',
  // GRID = 'grid',
  // MULTIGRID = 'multigrid',
  RUBRIC = 'rubric',
}

export interface GetAllProFormsSubmissionsAPIResponse {
  items: ProFormsSubmissionAPIResponse[];
  _links: {
    self: string;
    first: string;
    last: string;
    prev?: string;
    next?: string;
  };
  _meta: PaginationDTO;
}

export interface ProFormsSubmissionAPIResponse {
  id: number;
  proform_form_id: number;
  user_id: number;
  context_table: string;
  context_table_id: number;
  is_deleted: number;
  grade: number;
  pass_or_fail: string;
  user?: UserDTO;
  answers?: ProFormsAnswersAPIResponse[];
  created_at: number;
  updated_at: number;
}

export interface ProFormsAnswersAPIResponse {
  id: number;
  proform_form_submission_id: number;
  proform_form_question_id: number;
  proform_form_question_answer_option_id: number;
  text_answer: string;
  is_deleted: number;
  selectedCell: string;
  answerAttachment: ProFormsFileUploadItemResponse;
}

export interface ProFormsFileUploadItemResponse {
  type: string;
  relational_id: number;
  title: string;
  file_path: string;
  file_type: string;
  description: string;
  user_id: number;
  created_at: number;
  updated_at: number;
  id: number;
}

export interface CreateUpdateSectionAPIResponse {
  item: {
    proform_form_id: number;
    title: string;
    description: string;
    sort_order: number;
    id: number;
    is_conditional: number;
    conditional_question_id: number | null;
    conditional_question_answer_option_id: number | null;
  };
}

export interface ShareFormAPIResponse {
  item: {
    proform_form_id: number;
    district_id: number;
    is_shared: number;
    id: number;
  };
}

export interface UpdateFormAPIResponse {
  item: ProFormsAPIResponse;
}

export interface CreateAnswerOptionAPIResponse {
  item: {
    proform_form_id: number;
    proform_form_question_id: number;
    answer: string;
    sort_order: number;
    id: number;
  };
}

export interface UpdateAnswerOptionAPIResponse {
  item: {
    id: number;
    proform_form_id: number;
    proform_form_question_id: number;
    answer: string;
    is_correct: number;
    sort_order: number;
    next_section_override: string;
  };
}

export interface CreateUpdateProFormsQuestionAPIResponse {
  item: ProFormsQuestionAPIResponse;
}

export interface RubricFieldTypeSpecs {
  numbLevels: number;
  levelNames: string[];
  competencies: RubricFieldTypeCompetency[];
}
export interface RubricFieldTypeCompetency {
  title: string;
  gis: string[];
  editing?: boolean;
}

export interface CompetencyContentUpdate {
  index: number;
  title: string;
  gis: string[];
}

export interface BulkRegistrationPayload {
  send_to: string;
}
